import React from 'react';
import PropTypes from 'prop-types';
import DoneIcon from '@material-ui/icons/Done';
import styled from 'styled-components';

const DataTableBodyCellBooleanBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DataTableBodyCellBoolean = ({ value }) => {
  return <DataTableBodyCellBooleanBody>{!!value && <DoneIcon fontSize={'small'} />}</DataTableBodyCellBooleanBody>;
};

DataTableBodyCellBoolean.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default DataTableBodyCellBoolean;
